<template>
    <div class="display-single-user-master">
        <p><button @click="close">&larr; Назад</button></p>
        <h2>{{userData.union.udr_ime}}</h2>
        <p><i>Електронска пошта: {{userData.union.udr_email}}</i></p>
        <p><i>Матични број: {{userData.union.udr_mat_br}}</i></p>
        <p><i>ПИБ: {{userData.union.udr_pib}}</i></p>
        <p><i>Жиро рачун: {{userData.union.udr_ziro}}</i></p>
        <h3>Пројекти:</h3>
        <h3 v-if="!userData.projects || userData.projects.length===0"><i>Нема забележених пројеката</i></h3>
        <div v-for="(i,idx) in userData.projects" :key="'userProject'+idx">
            <span>{{i.pro_ime}}</span>
            <span>{{i.pro_br_ugovora}}</span>
            <span class="status-span"
                :class="{
                    'project-active-color':i.pro_status==='активан',
                    'project-archived-color':i.pro_status!=='активан'
                }"
            >{{i.pro_status}} </span>
            <button @click="openSingleProject(i.pro_id, i.pro_status)">Детаљније</button>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        userData:Object
    },
    methods:{
        openSingleProject(id, status){
            if(status==="активан"){
                sessionStorage.setItem("selectedProject", id);
                this.$router.push("/admin/projekti");
            }
            else{
                sessionStorage.setItem("selectedArchived", id);
                this.$router.push("/admin/arhiva");
            }
        },
        close(){
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss" scoped>
    .display-single-user-master{
        >p{
            button{
                @include ButtonStyling();
            }
            margin-left: 30px;
            &:first-of-type{
                margin-left: 0;
            }
        }
        h2, h3{
            text-align: center;
        }
        div{
            border-radius: 5px;
            margin: 10px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover{
                background-color: rgba(0, 0, 243, 0.23);
            }
            .status-span{
                flex-basis: 100px;
                display: inline-flex;
                border-radius: 5px;
                padding: 3px;
                justify-content: center;
                align-items: center;
            }
            >span:nth-of-type(2n+1){
                margin: 0 10px;
            }
            >span:nth-of-type(2n){
                margin-left: auto;
                margin-right: 20px;
            }
            button{
                @include ButtonStyling();
                margin: 0;
                font-weight: 400;
            }
        }
    }
    .project-active-color{
        background-color: green;
    }
    .project-archived-color{
        background-color: red;
    }

    @media only screen and (max-width: 768px) {
        .display-single-user-master{
            div{
                border-bottom: 1px solid lightblue;
                margin: 20px 0;
                padding-bottom: 20px;
                flex-direction: column;
                .status-span{
                    flex-basis: auto;
                }
                >span:nth-of-type(2n){
                    margin-left: 0;
                    margin-right: 0;
                }
                button{
                    margin: 5px 0;
                }
            }
        }
    }
</style>